import type { ButtonProps } from '@mui/material/Button';

import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';
import { useAuth } from 'react-oidc-context';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  const { t } = useTranslate();
  const { signoutRedirect } = useAuth();

  const handleLogout = useCallback(async () => {
    try {
      onClose?.();
      await signoutRedirect({
        post_logout_redirect_uri: window.location.origin,
      });
    } catch (error) {
      console.error(error);
    }
  }, [onClose, signoutRedirect]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      {t('buttons.logout')}
    </Button>
  );
}
